export default {"src":"https://assets.ctr1.net/d1a32bdc1f09/_next/static/media/jumpcloud.ebf2a3d5.svg","height":481,"width":996,"blurWidth":0,"blurHeight":0};